import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { SecuritySection } from '../components/SecuritySection';
import { FeaturesSection } from '../components/FeaturesSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { DemoSection } from '../components/DemoSection';
import { PricingSection } from '../components/PricingSection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-white" data-id="element-199">
      <Header data-id="element-200" />
      <main data-id="element-201">
        <Hero data-id="element-202" />
        <ProblemSection data-id="element-203" />
        <SolutionSection data-id="element-204" />
        <SecuritySection data-id="element-205" />
        <FeaturesSection data-id="element-206" />
        <BenefitsSection data-id="element-207" />
        <DemoSection data-id="element-208" />
        <PricingSection data-id="element-209" />
        <FAQSection data-id="element-210" />
      </main>
      <Footer data-id="element-211" />
    </div>;
}